// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
import { DefaultTFuncReturn } from 'i18next';
import styles from './styles.module.scss';
import { IconClose } from '../icons/IconClose';
import { mergeClasses } from 'util/commons';

type TableFilterExpandedValueProps = {
  value?: React.ReactNode;
  valueCondition?: boolean;
  clearCondition?: boolean;
  allowClear?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange?: (value: any) => void;
  placeholder?: string | DefaultTFuncReturn;
  icon?: React.ReactNode;
  className?: string;
};

const TableFilterExpandedValue: React.FC<TableFilterExpandedValueProps> = ({
  value,
  valueCondition,
  clearCondition,
  allowClear,
  onChange,
  placeholder,
  icon,
  className,
}) => {
  const clearable = allowClear && clearCondition;

  return (
    <div className={mergeClasses(styles.valueWrapper, className)}>
      <div className={styles.value}>
        {valueCondition && value ? value : placeholder}
      </div>
      <div
        className={styles.icon}
        onClick={(e) => {
          if (clearable) {
            e.preventDefault();
            e.stopPropagation();
            onChange?.(undefined);
          }
        }}
      >
        {clearable ? (
          <IconClose width={12} height={12} strokeColor="#9EA0A2" />
        ) : (
          icon
        )}
      </div>
    </div>
  );
};

TableFilterExpandedValue.defaultProps = {
  valueCondition: true,
  allowClear: true,
  clearCondition: true,
};

export default TableFilterExpandedValue;
